import { ReactComponent as IconSvg } from 'approot/shared/icons/icon_activities_active.svg';
import Icon, { IconProps } from './icon';

const IconActivitiesActive = (props: IconProps) => {
  return <Icon {...props} Svg={IconSvg} />;
};

export default IconActivitiesActive;
